import React, {useState, useRef, useEffect} from 'react';
import styles from './TooltipLeaderboard.module.css';

const TooltipLeaderboard = ({
    text,
    children,
    link,
    backgroundColor,
    displayedOnBottom = false,
    fontColor
}) => {
    const [hovered, setHovered] = useState(false);
    const [tooltipStyle, setTooltipStyle] = useState({});
    const [arrowStyle, setArrowStyle] = useState({});
    const tooltipRef = useRef(null);
    const hideTimer = useRef(null);

    const showTooltip = () => {
        clearTimeout(hideTimer.current);
        setHovered(true);
    };

    const hideTooltip = () => {
        hideTimer.current = setTimeout(() => setHovered(false), 150);
    };

    useEffect(() => {
        return () => clearTimeout(hideTimer.current);
    }, []);
    useEffect(() => {
        if (hovered && tooltipRef.current) {
            const tooltipRect = tooltipRef.current.getBoundingClientRect();
            const {innerWidth, innerHeight} = window;

            const offset = 8;
            let newStyle;
            if (displayedOnBottom) {
                newStyle = {
                    left: '50%',
                    transform: 'translateX(-50%)',
                    bottom: 'auto',
                    top: '100%',
                };
            } else {
                newStyle = {
                    left: '50%',
                    transform: 'translateX(-50%)',
                    // bottom: '120%',
                     bottom: 'calc(120% - 8px)', // Move the tooltip down for slight overlap
                    top: 'auto',
                };
            }

            let newArrowStyle = {
                left: '50%',
                transform: 'translateX(-50%)',
            };


            let shiftX = 0;

            if (tooltipRect.left < offset) {
                shiftX = offset - tooltipRect.left;
            } else if (tooltipRect.right > innerWidth - offset) {
                shiftX = -(tooltipRect.right - (innerWidth - offset));
            }


            newStyle.transform = `translateX(calc(-50% + ${shiftX}px))`;

            let arrowShiftX = -shiftX;
            newArrowStyle.transform = `translateX(calc(-50% + ${arrowShiftX}px))`;


            if (tooltipRect.top < offset) {
                newStyle.bottom = 'auto';
                newStyle.top = '100%';
            } else if (tooltipRect.bottom > innerHeight - offset) {
                newStyle.top = 'auto';
                // newStyle.bottom = '120%';
                newStyle.bottom = 'calc(120% - 8px)'; // Move the tooltip down for slight overlap
            }

            setTooltipStyle(newStyle);
            setArrowStyle(newArrowStyle);
        } else {
            setTooltipStyle({});
            setArrowStyle({});
        }
    }, [hovered]);

    return (
        <div
            className={styles.tooltipWrapper}
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
        >
            {children}

            {hovered && (
                <div
                    className={styles.tooltip}
                    ref={tooltipRef}
                    style={{
                        ...tooltipStyle,
                        '--tooltip-bg': backgroundColor,
                        '--tooltip-color': fontColor
                    }}
                >
                    {text}
                    {link && (
                        <a
                            href={link}
                            target="_blank"
                            rel="noreferrer"
                            className={styles.learnMoreLink}
                        >
                            Learn More
                        </a>
                    )}
                    <div
                        className={styles.arrow}
                        style={arrowStyle}
                    />
                </div>
            )}
        </div>
    );
};

export default TooltipLeaderboard;